<div class="mt-2">
    <div
        style="white-space: break-spaces;
        padding: 30px;
        background: #2d2c2c;
        color: #e3e3e3;
        font-family: 'consolas';
        font-size: 14px; border-radius: 10px;">
        <p>
            {{ currentUser() | json }}
        </p>
        @if(currentSelectedHospital()){
            <p>
                {{ currentSelectedHospital() |json }}
            </p>
        }
    </div>
</div>
